export const overrideProperties = (propTypes, defaultProps) => (props) =>
  Object.keys(propTypes).reduce((accumulator, key) => {
    if (props[key] === undefined && defaultProps[key] === undefined) return accumulator;

    return {
      ...accumulator,
      [key]: props[key] !== undefined && props[key] !== defaultProps[key] ? props[key] : defaultProps[key],
    };
  }, {});
